import { CATEGORY_STRUCTURE } from "../constants/categoryStructure";

const flattenSubcategories = (categories = []) =>
  categories.flatMap((category) => category?.subs ?? []);

export const buildCategoryMenuColumns = (categories = []) => {
  const allSubs = flattenSubcategories(categories);

  return CATEGORY_STRUCTURE.map((categoryConfig) => {
    const apiCategory = categories.find(
      (category) => +category?.hashtag?.id === categoryConfig.id
    );
    const title = apiCategory?.hashtag?.txt ?? categoryConfig.name;

    const links = categoryConfig.subcategories
      .map((subConfig) => {
        const apiSub =
          apiCategory?.subs?.find((sub) => +sub.id === subConfig.id) ??
          allSubs.find((sub) => +sub.id === subConfig.id);

        const label = apiSub?.txt ?? subConfig.name;

        if (!label) return null;

        return {
          id: subConfig.id,
          label,
          path: `/category/${subConfig.id}`,
        };
      })
      .filter(Boolean);

    return {
      id: `category-${categoryConfig.id}`,
      title,
      categoryId: categoryConfig.id,
      links,
    };
  }).filter((column) => column.links.length > 0);
};

